export default "__VITE_ASSET__Dz1R5SXB__"